import { render, staticRenderFns } from "./ContactCompanies.vue?vue&type=template&id=1f0cc0b8&"
import script from "./ContactCompanies.vue?vue&type=script&lang=js&"
export * from "./ContactCompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports